import React from "react";
import StudentRegisterPageSection from "../../Sections/StudentRegisterPageSection/Content";
const StudentRegisterPage = () => {
  return <StudentRegisterPageSection />;
};

export default StudentRegisterPage;
